import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { useDispatch } from 'react-redux';
import { LayoutType } from 'signup-components/types';
import { Small } from 'foundations-components/transitional/components/Small';
import { NextStepManager } from '../flow-management/NextStepManager';
import { setNextStep } from '../flow-management/setNextStep';
import { Button } from 'foundations-components/transitional/components/Button';
import { StyledUILink } from '../views-components/TextInput.styles';
import { Step } from 'signup-constants/Step';
import { useIsFramedCentredModalStep } from '../hooks/useIsFramedCerntredModalStep';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { isCanvasTheme, useTheme } from 'foundations-theming/utils';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const ResendCodeFooter = () => {
  const stepKey = Step.CodeVerification;
  const dispatch = useDispatch();
  const {
    layoutType
  } = useLayoutTemplate();
  const isSidePanel = layoutType === LayoutType.SidePanel;
  const {
    isFramedCentredModalStep
  } = useIsFramedCentredModalStep();
  const theme = useTheme();
  const goToResendEmailStep = event => {
    event.preventDefault();
    return dispatch(setNextStep({
      rebuilder: NextStepManager.pushNextSteps(Step.ResendEmail)
    }));
  };
  const Link = ({
    children,
    onClick
  }) => {
    if (isSidePanel || isCanvasTheme(theme)) {
      return /*#__PURE__*/_jsx(Flex, {
        alignItems: "baseline",
        display: "inline-flex",
        flexWrap: "nowrap",
        children: /*#__PURE__*/_jsx(Button, {
          padding: "0",
          use: "transparent",
          onClick: onClick,
          children: children
        })
      });
    }
    return /*#__PURE__*/_jsx(StyledUILink, {
      onClick: onClick,
      children: children
    });
  };
  return /*#__PURE__*/_jsx(View, {
    as: "div",
    marginBlockStart: isSidePanel && '500' || isFramedCentredModalStep && '300' || '600',
    children: /*#__PURE__*/_jsx(Text, {
      as: "div",
      textAlign: isFramedCentredModalStep ? 'center' : undefined,
      children: /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: {
            Link,
            strong: ({
              children
            }) => /*#__PURE__*/_jsx("span", {
              children: children
            }),
            br: () => {
              return isFramedCentredModalStep && /*#__PURE__*/_jsx("br", {});
            }
          },
          message: `views.${stepKey}.cantSeeEmail_jsx`,
          options: {
            onClick: goToResendEmailStep,
            href: ''
          }
        })
      })
    })
  });
};
export default ResendCodeFooter;